// removed by extract-text-webpack-plugin
module.exports = {"highlightedText":"SearchText__highlightedText___2RwA5"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/SearchText.css
// module id = 1570
// module chunks = 0